<div id="simple-page">
  <main>
    <div class="wrapper">
      <hyperkit-typography variant="h1" align="center" color="primary">
        Upgrade to gain access</hyperkit-typography
      >
      <hyperkit-typography
        variant="body"
        size="md"
        align="center"
        color="secondary"
      >
        Learn more about what the HUNTER Hunt Module can do for you and your
        organization.</hyperkit-typography
      >
      <div class="container">
        <hyperkit-typography
          class="title"
          variant="h3"
          align="center"
          color="primary"
        >
          HUNTER Hunt Module</hyperkit-typography
        >
        <hyperkit-typography
          variant="body"
          size="md"
          align="center"
          color="primary"
        >
          Elevate your threat hunting with powerful tools for planning,
          execution, reporting, and tracking with HUNTER's Hunt
          Module.</hyperkit-typography
        >
        <div class="points">
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Provide a space for teams to plan, execute, manage, and report on
              hunts.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            ></hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Generate detailed reports providing stakeholders with valuable
              insights.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              Develop structured templates to streamline the initiation,
              customization, and execution of future hunts.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              Gain clarity on the business impact of threat hunting activities
              by tracking hunt KPIs and Metrics.</hyperkit-typography
            >
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              Full API access included</hyperkit-typography
            >
          </div>
        </div>
        <div class="buttons">
          <hyperkit-button
            color="tertiary"
            [fullWidth]="true"
            text="Talk to Intel 471"
            (click)="talkToCyborg()"
          ></hyperkit-button>
          <hyperkit-button
            color="secondary"
            [fullWidth]="true"
            text="Learn More"
            (click)="learnMore()"
          ></hyperkit-button>
        </div>
      </div>
    </div>
  </main>
</div>
